import { Component } from '@angular/core';
import {
  ToastController,
  LoadingController,
  IonicPage,
  Events
} from 'ionic-angular';

import { UserService } from '../../providers/user-service';

import { API_TIMEOUT } from '../../providers/config';

@IonicPage()
@Component({
  selector: 'page-sign-in',
  templateUrl: 'sign-in.html'
})

export class SignInPage {
  username: any;
  password: any;

  constructor(
    public toastCtrl: ToastController,
    public events: Events,
    public userService: UserService,
    public loadingCtrl: LoadingController
  ) {
    // TODO: when initializing, look for session
    // if any found, push podcast list view
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad SignInPage');
  }

  submit(event) {
    let loader = this.loadingCtrl.create({
      content: 'Signing in...',
      duration: API_TIMEOUT
    });
    loader.present();
    if ((this.username) && (this.password)) {
      this.userService.authenticate(this.username, this.password).subscribe((data: any) => {
        loader.dismiss();
        if (data.token) {
          // authData should be persisted through sessions
          this.userService.setAuthData(data);
          // welcoming user and spamming login event
          this.displayWelcomeMessage(data.username);
          this.events.publish('user:login');
        } else {
          alert('Invalid username and/or password!');
        }
      });
    } else {
      alert('Fill username & password fields first!');
    }
    if (event) event.stopPropagation();
  }

  displayWelcomeMessage(username) {
    let toast = this.toastCtrl.create({
      message: `Welcome back ${username}!`,
      duration: 3000,
      position: 'top'
    });
    toast.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/sign-in/sign-in.ts